import React, { Fragment } from 'react';
import { object } from 'prop-types';
import { UncontrolledPopover, PopoverHeader, PopoverBody, UncontrolledTooltip } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { currencyToSign } from '../../utils/utils';
import { getStoreUrl } from '../../utils/utils';
import { STATIC_PATH } from '../../config';
import { FMessage } from '../../hoc/IntlComponents';
import Icon from '../Icon/Icon';

const propTypes = {
  pixel: object.isRequired,
};

const defaultProps = {
  pixel: {},
};

const getPixelReward = ({ text_summ = '', summ = '', currency }) =>
  text_summ ? text_summ : `${summ} ${currencyToSign(currency)}`;

const renderCoinTooltip = () => {
  return (
    <UncontrolledPopover
      trigger="hover"
      className="offer-coins-popover"
      placement="left"
      target={`pixel-coins`}
    >
      <PopoverHeader>
        {' '}
        <b>
          <FMessage id="offer.geo_bonus_coins.tooltip.title" />
        </b>
      </PopoverHeader>
      <PopoverBody>
        {' '}
        <div>
          <FormattedMessage
            id="offer.geo_bonus_coins.tooltip.body"
            defaultMessage="According to this GEO,  2 coins is charged for a confirmed application. Coins you can spend on "
          />
          <a href={getStoreUrl()} target="_blank">
            <FMessage id="offer.tooltip.link-to-store" />
          </a>
        </div>
      </PopoverBody>
    </UncontrolledPopover>
  );
};

const renderCoins = () => (
  <div id={`pixel-coins`} className={`coins-2`}>
    <img src={`${STATIC_PATH}/img/coin-big.svg`} />
    <img src={`${STATIC_PATH}/img/coin-big.svg`} />
    {renderCoinTooltip()}
  </div>
);

const checkPixelForKZ = title => {
  const regex = /казахстан|kazakhstan/;

  return regex.test(title.toLowerCase()) && (new Date).getTime() < 1559336340000;
};

const renderCrownTooltip = id => {
  return (
    <UncontrolledTooltip
      placement="left"
      delay={{ show: 150, hide: 150 }}
      target={`pixel_crown_${id}`}
      className='tooltip-offer-geo-bonus-crown'
    >
      <FMessage id="offer.geo_bonus_crown.tooltip.text" />
    </UncontrolledTooltip>
  );
};

const PixelListItem = ({ pixel, isCdn, coins }) => {
  const renderCrown = () => {
    if(pixel.icons && pixel.icons.crown) {
      return (
        <Fragment>
          <Icon type='crown' id={`pixel_crown_${pixel.id}`} />
          {renderCrownTooltip(pixel.id)}
        </Fragment>
      );
    } else {
      return null;
    }
  };

  const formatTitle = (title) => (title.includes('Подтвержденная заявка') && title.indexOf('(') > 0 && title.indexOf(')') > 0) ? title.slice(title.indexOf('(') + 1, title.indexOf(')')) : title;


  return (
    <li className="pixel-list-item">
      <span className="pixel-title">
        {pixel.title} {isCdn && coins === 1 && checkPixelForKZ(pixel.title) && renderCoins()}
      </span>
      <span className="pixel-reward">
        {renderCrown()}
        {getPixelReward(pixel)}
      </span>
    </li>
  );
};

PixelListItem.propTypes = propTypes;
PixelListItem.defaultProps = defaultProps;

export default PixelListItem;
